import { InjectionToken } from "@angular/core";

// Outside the generated client, which imports it from here, so app.module can provide it eagerly (PROXY-7).
export const WEBHOOKS_API_BASE_URL = new InjectionToken<string>("WEBHOOKS_API_BASE_URL");
